import * as React from 'react';
import { forwardRef } from 'react';
import { c as createNolIcon } from '../utils/index.js.mjs';

function SvgIcLandmark(props, ref) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    width: "24",
    height: "24",
    fill: "none",
    viewBox: "0 0 24 24",
    ref: ref
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M2.963 3.226a.75.75 0 0 1 .744-.197q.791.228 1.524.443c1.515.441 2.833.825 3.974 1.1 1.147.276 2.065.428 2.788.428.715 0 1.621-.15 2.752-.42 1.126-.27 2.426-.647 3.925-1.082q.778-.226 1.624-.47a.75.75 0 0 1 .921.947l-.85 2.7a.75.75 0 0 1-.526.5l-.873.229-.842 1.262A.75.75 0 0 1 17.5 9h-11a.75.75 0 0 1-.624-.334l-.842-1.262-.873-.228a.75.75 0 0 1-.526-.5l-.85-2.7a.75.75 0 0 1 .178-.75m16.402 1.632-.277.08-.014.005c-1.482.43-2.815.817-3.98 1.096-1.162.278-2.205.461-3.1.461-.905 0-1.963-.187-3.14-.47-1.18-.284-2.53-.677-4.028-1.114l-.014-.004-.176-.052.305.969.748.195a.75.75 0 0 1 .435.31L6.901 7.5H17.1l.777-1.166a.75.75 0 0 1 .435-.31l.748-.195zM12.75 9v3.5h-1.5V9z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M17.25 8v8.5h-1.5V8zM8.25 8v8.5h-1.5V8z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M7.25 17a1 1 0 0 1-.007.1l-.5 3.75-1.486-.2.494-3.708c.028-.724.575-1.442 1.416-1.442h.666c.84 0 1.388.718 1.416 1.442l.494 3.709-1.486.198-.5-3.75A1 1 0 0 1 7.75 17zM16.25 17a1 1 0 0 1-.007.1l-.5 3.75-1.486-.2.494-3.708c.028-.724.575-1.442 1.416-1.442h.666c.84 0 1.388.718 1.416 1.442l.494 3.709-1.486.198-.5-3.75A1 1 0 0 1 16.75 17z",
    clipRule: "evenodd"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M3.006 21.25a.75.75 0 0 1 .75-.75H20.4a.75.75 0 0 1 0 1.5H3.756a.75.75 0 0 1-.75-.75M4.75 12.75A.75.75 0 0 1 5.5 12h13a.75.75 0 0 1 0 1.5h-13a.75.75 0 0 1-.75-.75",
    clipRule: "evenodd"
  }));
}
var IcLandmark = createNolIcon(/*#__PURE__*/forwardRef(SvgIcLandmark));

export { IcLandmark as I };
